function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0556449,41.6661906 L0.305453063,1.91662959 C-0.112947155,1.4670992 -0.0995777941,0.768344537 0.333642664,0.333626314 C0.76833679,-0.0995727114 1.46715175,-0.112941645 1.9166965,0.305437614 L41.6668883,40.0549987 C41.9918056,40.3813905 42.0897323,40.8709594 41.9131732,41.2967523 C41.7366217,41.7225453 41.3211992,41.9999886 40.8612856,41.9999886 C40.5585987,42 40.2692888,41.8798277 40.0556449,41.6661906 Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.0868234345,41.2967525 C-0.0897281608,40.8709597 0.00819105181,40.3813606 0.333108428,40.0549992 L40.0833084,0.305443228 C40.5328533,-0.112943518 41.2316306,-0.099574588 41.6663629,0.333631921 C42.0995759,0.768312052 42.1129453,1.46710451 41.6945525,1.91663479 L1.94435253,41.6661907 C1.73070854,41.8798278 1.44140609,42 1.13873428,42 C0.678797698,41.9999886 0.263359837,41.7225567 0.0868234345,41.2967525 Z"
});

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a059a437.svg";
export { ForwardRef as ReactComponent };